export default "__VITE_ASSET__64fe4f84__"